import React, { useEffect, useRef, useState } from "react";
import userService from "../../../services/user.service";
import AllTestimonial from "./AllTestimonial";
import { Field, Form, Formik } from "formik";
import validationSchema from "../../../Validation/ValidationSchemas";
import SuccessDialog from "../../schoolAdminPortal/Popups/SuccessDialog";
const Testimonials = () => {
  const [heading, setHeading] = useState({});
  const [testimonialsHeading, setTestimonialsHeading] = useState("");
  const [testimonialsHeadingId, setTestimonialsHeadingId] = useState(null);
  const [testimonialsdetails, setTestimonialsdetails] = useState("");
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const formRef = useRef();

  // get heading
  useEffect(() => {
    getHeading();
  }, []);

  const handleSubmit = () => {
    formRef.current.handleSubmit();
  };

  const getHeading = () => {
    userService.getTestimonialsHeading().then((res) => {
      const headingData = res.data.data[0];
      setHeading(headingData);
      setTestimonialsHeadingId(headingData.id);
    });
  };

  // add heading and description
  const addHeading = ({ title, details }) => {
    userService.addTestimonialHeading(title, details).then((res) => {
      if (res.status === 200) {
        setMsg("Testimonials Heading & details added successfully");
        setOpen(true);
      }
    });
  };

  // update heading
  const updateHeding = ({ title, details }) => {
    userService
      .updateTestimonialsHeading(heading.id, details, title)
      .then((res) => {
        if (res.status === 200) {
          setMsg("Testimonials Heading & details updated successfully");
          setOpen(true);
          getHeading();
        }
      });
  };

  const toggleSuccessDialog = () => {
    setOpen(!open);
  };

  return (
    <div>
      <div className="panel-content conclass-website">
        <Formik
          innerRef={formRef}
          initialValues={{
            title: heading ? heading.testimonialsHeading : testimonialsHeading,
            details: heading
              ? heading.testimonialsDetails
              : testimonialsdetails,
          }}
          enableReinitialize
          validationSchema={validationSchema.testimonialsSectionSchema}
          onSubmit={(values) => {
            heading ? updateHeding(values) : addHeading(values);
          }}
        >
          {(formik) => (
            <Form>
              <div className="row">
                <div className="col-lg-8 col-md-8">
                  <label for="comment" className="black fs-18 detailstxt">
                    TESTIMONIALS HEADING
                  </label>
                  {heading ? (
                    <div>
                      <Field
                        type="text"
                        name="title"
                        className={`form-control w-100 faqtextbox1 ${
                          formik.errors.title && "is-invalid"
                        }`}
                        placeholder="Multi-angle capture"
                      />
                      <div className="errorMsg fs-14 medium">
                        {formik.touched.title && formik.errors.title}
                      </div>
                    </div>
                  ) : (
                    <input
                      type="text"
                      name=""
                      className="w-100 emailtxtbox"
                      placeholder="Happy Teams"
                      onChange={(event) => {
                        setTestimonialsHeading(event.target.value);
                      }}
                      value={testimonialsHeading}
                    ></input>
                  )}
                </div>
                <div className="col-lg-4 col-md-4"></div>
              </div>
              <div className="clear20"></div>
              <div className="row">
                <div className="col-lg-8 col-md-12">
                  <div class="form-group display-grid">
                    <label for="comment" className="black fs-18 detailstxt">
                      DESCRIPTION
                    </label>
                    {heading ? (
                      <div>
                        <Field
                          as="textarea"
                          rows="3"
                          col="12"
                          id="comment"
                          name="details"
                          className={`form-control fs-16 w-100 faqanswerbox ${
                            formik.errors.details && "is-invalid"
                          }`}
                        />
                        <div className="errorMsg fs-14 medium">
                          {formik.touched.details && formik.errors.details}
                        </div>
                      </div>
                    ) : (
                      <textarea
                        rows="3"
                        col="12"
                        id="comment"
                        className="teaxtareatxt fs-18"
                        placeholder=""
                        onChange={(event) => {
                          setTestimonialsdetails(event.target.value);
                        }}
                        value={testimonialsdetails}
                      ></textarea>
                    )}
                  </div>
                </div>
              </div>
              <div className="d-flex-align-cent mg-top-20">
                <button type="button" className="cancelbtn mr-2">
                  Cancel
                </button>
                <button
                  type="submit"
                  className={`${
                    formik.isValid ? "saveBtn1" : "saveBtn1 activv"
                  }`}
                  disabled={!formik.isValid}
                  onClick={() => handleSubmit()}
                >
                  Save
                </button>
              </div>
            </Form>
          )}
        </Formik>

        <AllTestimonial testimonialsHeadingId={testimonialsHeadingId} />
        <div className="clear20"></div>

        <div className="clear20"></div>
      </div>
      <SuccessDialog
        successPopUp={open}
        msg={msg}
        toggleSuccessDialog={toggleSuccessDialog}
      />
    </div>
  );
};

export default Testimonials;
